import { __awaiter } from "tslib";
import { computed, defineComponent, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { Actions as SchemaActions } from '@/store/enums/hrgs/master/SchemaEnum';
import { Actions as AnswerTypeActions } from '@/store/enums/hrgs/AnswerTypeEnum';
import { Actions as CompetencyUnitActions } from '@/store/enums/hrgs/master/CompetencyUnitEnum';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
// Component per form code
import FRAPL02 from './SchemaByFormCode/FR.APL.02.vue';
import FRIA01 from './SchemaByFormCode/FR.IA.01.vue';
import FRIA02 from './SchemaByFormCode/FR.IA.02.vue';
import FRIA03 from './SchemaByFormCode/FR.IA.03.vue';
import FRIA07 from './SchemaByFormCode/FR.IA.07.vue';
import FRIA08 from './SchemaByFormCode/FR.IA.08.vue';
import FRIA09 from './SchemaByFormCode/FR.IA.09.vue';
import FRIA10 from './SchemaByFormCode/FR.IA.10.vue';
import { validationRequired } from '@/core/helpers/validation';
export default defineComponent({
    components: {
        FRAPL02,
        FRIA01,
        FRIA02,
        FRIA03,
        FRIA07,
        FRIA08,
        FRIA09,
        FRIA10
    },
    props: {
        scheme: {
            type: Object,
            default: () => {
                return {};
            }
        },
        statementFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        relevantEvidenceFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        competencyUnitFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        disabled: Boolean,
        preview: Boolean,
        isAssessment: Boolean,
        order: Number,
        formRef: Object
    },
    emits: ['update:scheme', 'selectSchema', 'selectAnswerType'],
    setup(props, { emit }) {
        const modelSchema = computed({
            get() {
                return props.scheme;
            },
            set(value) {
                emit('update:scheme', value);
            }
        });
        const store = useStore();
        // *start COMPUTED ============================================================
        const employeeID = computed(() => {
            return store.getters.currentUser.employeeID;
        });
        // if haveStatementFields, its means in the assessment form
        const haveStatementFields = computed(() => {
            if (props.statementFields.length > 0)
                return true;
            return false;
        });
        const activedCompetencyUnit = computed(() => {
            return competencyUnitList.value.find((item) => {
                return item.id === activedCompetencyUnitId.value;
            });
        });
        // !end COMPUTED =============================================================
        // get List Options
        const schemaOptions = ref([]);
        const answerTypeOptions = ref([]);
        watch(employeeID, (value) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (value) {
                const payload = { employeeID: value, pageSize: 9999 };
                const result = yield Promise.allSettled([
                    store.dispatch(SchemaActions.GET_LIST, payload),
                    store.dispatch(AnswerTypeActions.GET_ANSWER_TYPE)
                ]);
                schemaOptions.value = (_a = result[0].value) === null || _a === void 0 ? void 0 : _a.map((item) => {
                    return {
                        label: item.title,
                        value: item.id
                    };
                });
                answerTypeOptions.value = (_b = result[1].value) === null || _b === void 0 ? void 0 : _b.map((item) => {
                    return {
                        label: item.name,
                        value: item.id
                    };
                });
            }
        }), {
            immediate: true
        });
        // watch schemeId and answerTypeId
        const competencyUnitOptions = ref({
            data: [],
            loading: false
        });
        const activedCompetencyUnitId = ref('');
        watch([
            () => {
                return modelSchema.value.schemeId;
            },
            () => {
                return modelSchema.value.answerTypeId;
            }
        ], ([valueA, valueB]) => __awaiter(this, void 0, void 0, function* () {
            if (!(valueA && valueB))
                return;
            competencyUnitOptions.value.loading = true;
            try {
                const schemaResult = yield store.dispatch(SchemaActions.GET_COMPETENCY_BY_SCHEMA_ANSWERTYPE, {
                    employeeID: employeeID.value,
                    schemaID: valueA,
                    answerTypeId: valueB
                });
                competencyUnitOptions.value = {
                    data: schemaResult,
                    loading: true
                };
                try {
                    const unitCompetencyResult = (yield Promise.allSettled(schemaResult.map((item) => {
                        return store.dispatch(CompetencyUnitActions.GET_DETAIL, {
                            employeeID: employeeID.value,
                            id: item.id
                        });
                    })));
                    unitCompetencyResult
                        .filter((item) => {
                        return item.status === 'fulfilled';
                    })
                        .forEach((item) => {
                        const foundIndex = competencyUnitOptions.value.data.findIndex((option) => {
                            return option.id === item.value.id;
                        });
                        if (foundIndex >= 0) {
                            competencyUnitOptions.value.data[foundIndex].competencyUnit =
                                item.value;
                        }
                    });
                    competencyUnitOptions.value.loading = false;
                    activedCompetencyUnitId.value =
                        competencyUnitOptions.value.data[0].id;
                    if (!haveStatementFields.value &&
                        modelSchema.value.answerFields &&
                        modelSchema.value.answerFields.length === 0) {
                        modelSchema.value.answerFields = [];
                        modelSchema.value.statementDetailColumnEnabled = false;
                        modelSchema.value.statementDetailColumnLabel = '';
                        // Set Value
                        modelSchema.value.statementColumnLabel = 'Pernyataan';
                        competencyUnitOptions.value.data.forEach((item) => {
                            if (haveLevelTwo(item.competencyUnit.customAnswerFields)) {
                                modelSchema.value.statementDetailColumnEnabled = true;
                                modelSchema.value.statementDetailColumnLabel =
                                    'Kriteria Untuk Kerja';
                            }
                            setCustomAnswerTypeColumn(item.competencyUnit.customAnswerFields).forEach((customAnswerField) => {
                                modelSchema.value.answerFields.push({
                                    answerFieldId: customAnswerField.answerField.id,
                                    label: customAnswerField.label,
                                    isVisible: true
                                });
                            });
                        });
                    }
                }
                catch (error) {
                    // hrgsSwalAlert({
                    //   icon: 'error',
                    //   text: 'Failed get competency unit.'
                    // })
                }
            }
            catch (error) {
                hrgsSwalAlert({ icon: 'error', text: 'Failed get schema.' });
                competencyUnitOptions.value.loading = false;
            }
        }), {
            immediate: true
        });
        const setCustomAnswerTypeColumn = (customAnswerFields = []) => {
            return (customAnswerFields.filter((item) => {
                return item.answerType.id === modelSchema.value.answerTypeId;
            }) || []);
        };
        const haveLevelTwo = (customAnswerFields = []) => {
            if (customAnswerFields.length) {
                return setCustomAnswerTypeColumn(customAnswerFields).some((item) => {
                    return item.answerField.level === 2;
                });
            }
            return false;
        };
        const competencyUnitList = computed(() => {
            if (props.isAssessment) {
                return competencyUnitOptions.value.data
                    .filter((item) => {
                    return props.statementFields
                        .map((item) => {
                        return item.competencyUnitId;
                    })
                        .includes(item.id);
                })
                    .map((item) => {
                    var _a;
                    return Object.assign(Object.assign({}, item), { competencyUnit: Object.assign(Object.assign({}, item.competencyUnit), { statements: ((_a = item.competencyUnit) === null || _a === void 0 ? void 0 : _a.statements.filter((item) => {
                                return props.statementFields
                                    .map((item) => {
                                    return item.statement.id;
                                })
                                    .includes(item.id);
                            })) || [] }) });
                });
            }
            return competencyUnitOptions.value.data;
        });
        const completedList = ref([]);
        const setCompleted = (value, competencyId) => {
            const foundCompetency = completedList.value.findIndex((item) => {
                return item.id === competencyId;
            });
            if (foundCompetency >= 0) {
                completedList.value[foundCompetency] = {
                    id: competencyId,
                    completed: value
                };
            }
            else {
                completedList.value.push({ id: competencyId, completed: value });
            }
        };
        return {
            validationRequired,
            modelSchema,
            schemaOptions,
            answerTypeOptions,
            competencyUnitOptions,
            activedCompetencyUnitId,
            activedCompetencyUnit,
            competencyUnitList,
            setCompleted,
            completedList
        };
    }
});
